import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Admin from "./Component/Admin/Admin";
import AllPostsAdmin from "./Component/AllPostsAdmin/AllPostsAdmin";
import NewPostsAdmin from "./Component/NewPostsAdmin/NewPostsAdmin";

ReactDOM.render(
    <Router>
        <Switch>
            <Route exact path="/" component={Admin}/>
            <Route exact path="/all-posts-admin" component={AllPostsAdmin}/>
            <Route exact path="/new-posts-admin" component={NewPostsAdmin}/>
        </Switch>
    </Router>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
